export const phoneToStr = (phone) => phone.replace(/[()_-\s]/g, '');

export const strToPhone = (str) => {
  const pos = (start, steap) => str.slice(start, start + steap);

  return `${pos(0, 2)} (${pos(2, 3)}) ${pos(5, 3)}-${pos(8, 2)}-${pos(10, 2)}`;
};
